import logo from './logo.svg';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Menu from './components/Menu/Menu';
import Projects from './pages/projects';
import Files from './pages/files';
import Home from './pages/home';
import EntitySearch from './pages/entitysearch';
import KeywordSearch from './pages/keywordsearch';
import QuerySearch from './pages/querysearch';
import Account from './pages/account';
import SavedSearch from './pages/savedsearches';
import EntitySerachReports from './pages/entityserachreports';
import KeywordSerachReports from './pages/keywordserachreports';
import React, { useEffect } from 'react'
import SearchType from './pages/searchtype';
import QuerySerachReports from './pages/queryserachreports';
import '@aws-amplify/ui-react/styles.css'
import { HashRouter } from 'react-router-dom'

function App() {
  return (
    
    <HashRouter>
      <Menu />
      <Routes>
				<Route exact path='/' element={<Home/>} />
				<Route path="/searchtype" element={<SearchType/>}/>
				<Route exact path='/projects' element={<Projects />} />
				<Route path='/account' element={<Account  />} />
				<Route path='/files' element={<Files />} />
				<Route path='/savedsearches' element={<SavedSearch />} />
				<Route path='/keywordsearch' element={<KeywordSearch  />} />
				<Route path='/entitysearch' element={<EntitySearch  />} />
				<Route path='/querysearch' element={<QuerySearch  />} />
				<Route path='/entityserachreports' element={<EntitySerachReports />} />
				<Route path='/keywordserachreports' element={<KeywordSerachReports />} />
				<Route path='/queryserachreports' element={<QuerySerachReports />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
